import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Lupa password?"
      subtitle="Masukkan email Anda dan kami akan membantu memulihkan akun Anda."
      footer={<>Ingat password Anda? <Link to="/login" className="font-semibold text-brand hover:underline" data-testid="link-login">Masuk</Link></>}
    >
      {sent ? (
        <div className="rounded-xl border border-borderc bg-white p-6 text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto h-10 w-10 text-brand-accent" />
          <h3 className="mt-3 font-heading text-lg font-semibold text-ink">Permintaan diterima</h3>
          <p className="mt-2 text-sm text-ink-soft">
            Jika email terdaftar, tautan reset password telah dibuat. Pada mode pengembangan, tautan reset dicatat di log server.
          </p>
          <Link to="/login"><Button className="mt-5 w-full h-11 bg-brand hover:bg-brand-hover">Kembali ke halaman masuk</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          {error && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="forgot-error">{error}</div>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="forgot-email"
              className="mt-1.5 h-11" placeholder="nama@email.com"
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 bg-brand hover:bg-brand-hover">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kirim tautan reset"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
